<template>
  <div class="my">
   <div>
      <img src="@/assets/img/content/my/my.png" alt="" style="width:100%">
   </div>
   <div class="modelMy">
     <div class="mdelDiv" style="width:66%;background:#fead15;margin-right:1%" @click="handleMeaasge">
       <img src="@/assets/img/content/my/icon_tourism_shop.png" alt="" style="width:4rem">
       <span>旅游商城</span>
     </div>
     <div class="mdelDiv" style="width:33%;background:#01999d;" @click="handleMeaasge">
        <img src="@/assets/img/content/my/icon_tourism_tickets.png" alt="" style="width:2rem">
        <span>门票</span>
     </div>
   </div>
  <div class="modelMy">
     <div class="mdelDiv" style="width:33%;background:#6f52a0;margin-right:1%" @click="handleMeaasge">
       <img src="@/assets/img/content/my/icon_tourism_vusu.png" alt="" style="width:2rem">
       <span>住宿</span>
     </div>
     <div class="mdelDiv" style="width:33%;background:#e60012;margin-right:1%" @click="handleMeaasge">
        <img src="@/assets/img/content/my/icon_tourism_food.png" alt="" style="width:2rem">
        <span>美食</span>
     </div>
      <div class="mdelDiv" style="width:33%;background:orange;" @click="handleMeaasge">
        <img src="@/assets/img/content/my/icon_tourism_teij.png" alt="" style="width:2rem">
        <span>特产</span>
     </div>
   </div>
   <div class="modelMy">
     <div class="mdelDiv" style="width:33%;background:#009944;margin-right:1%" @click="handleMeaasge">
        <img src="@/assets/img/content/my/icon_tourism_out.png" alt="" style="width:2rem">
        <span>出行</span>
     </div>
     <div class="mdelDiv" style="width:66%;background:#01999d;" @click="handleMeaasge">
       <span>旅游攻略</span>
     </div>
   </div>
  </div>
</template>
<script>
export default {
  methods:{
    handleMeaasge(){
      this.$message('功能即将上线');
    }
  }
}
</script>
<style>
.my{
  color:#FFF;
  margin: 0.5rem;
  padding-top: 0.5rem
}
.modelMy{
  display:flex;height:5rem;width:100%;margin-bottom:0.5rem
}
.mdelDiv{
  height:5rem;display: flex;justify-content: center;align-items: center;
}
.mdelDiv img{
  margin-right: 0.5rem  
}
</style>

